import { render } from "./DigitalServicePage.vue?vue&type=template&id=a0440c68"
import script from "./DigitalServicePage.vue?vue&type=script&lang=js"
export * from "./DigitalServicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__